module.exports = __webpack_public_path__ + "img/highlands-park-fc.8fc24de7.png";